/**
 * "What moved": the reading's cards, each with the package's direction words
 * when it gives one (Sprint 1.9.9 P2, D12).
 *
 * The glyph (drawn by `mirror.css`) is decoration in one neutral ink — never green for "above", which
 * would call a direction good, and is wrong for a scale that reads the other
 * way. The words beside it are `direction_labels[code]`, verbatim, and a card
 * with no direction is its title alone. `Home.tsx` hands every string in.
 */
/** The codes `mirror.css` draws a glyph for; any other code gets none. */
const GLYPHS: ReadonlySet<string> = new Set(['above', 'around', 'below'])

export interface ChipView {
  key: string
  title: string
  code: string | null
  words: string | null
}

export function WhatMoved({ chips }: { chips: readonly ChipView[] }) {
  if (chips.length === 0) return null
  return (
    <ul className="moved" data-testid="home-chips">
      {chips.map((chip) => (
        <li className="moved__chip" key={chip.key}>
          <b>{chip.title}</b>
          {chip.code !== null && GLYPHS.has(chip.code) && (
            <span className={`moved__glyph moved__glyph--${chip.code}`} aria-hidden="true" />
          )}
          {chip.words !== null && <span>{chip.words}</span>}
        </li>
      ))}
    </ul>
  )
}
